/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteDtoModel, RouteDtoModelType } from "./RouteDtoModel"
import { RouteDtoModelSelector } from "./RouteDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  route: RouteDtoModelType;
}

/**
 * RouteStopRescheduledDtoBase
 * auto generated base class for the model RouteStopRescheduledDtoModel.
 *
 * Route rescheduled event
 */
export const RouteStopRescheduledDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteStopRescheduledDto')
  .props({
    __typename: types.optional(types.literal("RouteStopRescheduledDto"), "RouteStopRescheduledDto"),
    /** Payload of route rescheduled */
    route: types.union(types.undefined, MSTGQLRef(types.late((): any => RouteDtoModel))),
    success: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteStopRescheduledDtoModelSelector extends QueryBuilder {
  get success() { return this.__attr(`success`) }
  route(builder: string | RouteDtoModelSelector | ((selector: RouteDtoModelSelector) => RouteDtoModelSelector) | undefined) { return this.__child(`route`, RouteDtoModelSelector, builder) }
}
export function selectFromRouteStopRescheduledDto() {
  return new RouteStopRescheduledDtoModelSelector()
}

export const routeStopRescheduledDtoModelPrimitives = selectFromRouteStopRescheduledDto().success
